import { Box, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactNode } from "react";

interface ReportSettingsModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

const ReportSettingsModal = ({
  open,
  onClose,
  title = "Settings",
  children,
}: ReportSettingsModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        {title}
        <IconButton
          aria-label="Close settings"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>{children}</Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReportSettingsModal;
